import script from "./FiltersModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FiltersModal.vue?vue&type=script&setup=true&lang=ts"

import "./FiltersModal.vue?vue&type=style&index=0&id=a1da9892&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1da9892"]])

export default __exports__